import React from 'react';
import { useTranslation } from 'react-i18next';

const Nav = () => {
    const { t, i18n } = useTranslation();

    const changeLanguage = (lng: 'en' | 'es') => {
        i18n.changeLanguage(lng);
    };

    return (
        <nav className="nav">
            <div className="nav__links">
                <a href="#work" className="nav__link">{t('navWork')}</a>
                <a href="#contact" className="nav__link">{t('navContact')}</a>
            </div>
            <div className="nav__lang-toggle">
                <button
                    type="button"
                    className={`nav__lang-btn${i18n.language === 'en' ? ' nav__lang-btn_active' : ''}`}
                    onClick={() => changeLanguage('en')}
                >
                    EN
                </button>
                <button
                    type="button"
                    className={`nav__lang-btn${i18n.language === 'es' ? ' nav__lang-btn_active' : ''}`}
                    onClick={() => changeLanguage('es')}
                >
                    ES
                </button>
            </div>
        </nav>
    );
};

export default Nav;
